import React from 'react';
import { Modal } from 'antd';
import styles from './MediaPreviewModal.module.css'; // must match your actual file name

const MediaPreviewModal = ({ previewVisible, setPreviewVisible, previewFile }) => {
    return (
        <Modal
            open={previewVisible}
            footer={null}
            onCancel={() => setPreviewVisible(false)}
            width={850}
            className="custom-media-modal" // keep global override class here
        >
            <div className={styles.container}>
                {previewFile?.type === 'image' && (
                    <img
                        alt="Preview"
                        className={styles.mediaImage}
                        src={previewFile.url}
                    />
                )}

                {previewFile?.type === 'video' && (
                    <video controls className={styles.mediaVideo}>
                        <source src={previewFile.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                )}

                {previewFile?.type === 'pdf' && (
                    <iframe
                        src={previewFile.url}
                        className={styles.mediaPdf}
                        title="PDF Preview"
                    />
                )}
            </div>
        </Modal>
    );
};

export default MediaPreviewModal;
